import { render, staticRenderFns } from "./ShareScaleConfigModal.vue?vue&type=template&id=57940722&scoped=true"
import script from "./ShareScaleConfigModal.vue?vue&type=script&lang=js"
export * from "./ShareScaleConfigModal.vue?vue&type=script&lang=js"
import style0 from "./ShareScaleConfigModal.vue?vue&type=style&index=0&id=57940722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57940722",
  null
  
)

export default component.exports